export const COF_TYPE_SCHEDULED = 'SCHEDULED';
export const COF_TYPE_UNSCHEDULED = 'UNSCHEDULED';
export const COF_TYPE_ONECLICK = 'ONECLICK';



// WEBPACK FOOTER //
// ./src/bridge/BridgeConstants.js